import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import EventEmitter from '../../utils/events'

// Actions
import { getCollaboratingPartners } from '../../actions/collaboratingPartners'

// import styles

// import components
import LeftMenuContent from '../../shared/components/Menus/LeftMenu/Content'
import Header from '../../shared/components/Header'

// Elements
import SideMenu from '../../shared/elements/sideMenu'
import SideMenuItem from '../../shared/elements/sideMenuItem'

// Views
import View from './View'

// Utils
import { hasSubscriptionPermission } from '../../utils/auth'

class CollaboratintPartners extends Component {

  constructor (props) {
    super(props)
    this.state = {
      view: 'list',
      activeItem: {},
      partnerList: []
    }

    this.renderList = this.renderList.bind(this)
    this.onSelectItem = this.onSelectItem.bind(this)
    this.renderView = this.renderView.bind(this)
  }

  componentDidMount () {
    this.getCollaboratingPartners()
  }

  getCollaboratingPartners () {
    this.props.getCollaboratingPartners().then((res) => {
      this.setState({
        partnerList: res.data
      })
    })
  }

  onSelectItem (item, key) {
    this.setState({
      view: 'item',
      activeItem: item
    })
    EventEmitter.emit('sidebar_trigger', false)
  }

  renderList () {
    const renderPartnerListPartners = (partner, key) => {
      return (
        <SideMenuItem
          label={partner.PartnerShopName}
          onClick={() => this.onSelectItem(partner)}
          selected={partner.Id === this.state.activeItem.Id}
          key={partner.Id}
        />
      )
    }

    return [
      ...this.state.partnerList.map(partner => {
        return (
          <div key={partner.Id}>
            <SideMenuItem
              label={partner.ShopName}
              onClick={() => this.onSelectItem(partner)}
              selected={partner.Id === this.state.activeItem.Id}
              key={partner.Id}
              isTitle
            />
            {partner.Partners.map(renderPartnerListPartners)}
          </div>
        )
      })
    ]
  }

  renderView () {
    switch (this.state.view) {
      case 'list':
        return <div />
      case 'item': {
        return <View ref='view' item={this.state.activeItem} parentName={this.state.parentPartnerShopName} />
      }
    }
  }

  render () {
    return (
      <div className='collaboratingPartner__screen'>
        <Header router={this.props.router} />
        <SideMenu showFilter={false} hideInactiveCheck>
          {this.renderList()}
        </SideMenu>

        <LeftMenuContent className='collaboratingPartner__screen--inner'>
          {this.renderView()}
        </LeftMenuContent>
      </div>
    )
  }

}

CollaboratintPartners.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, { hasSubscriptionPermission, getCollaboratingPartners })(CollaboratintPartners)



// WEBPACK FOOTER //
// ./src/app/pages/CollaboratingPartners/index.js